import { setHeight } from './LinearProgress/styles';
import { LinearProgressProps, ProgressColor, ProgressSize } from './types';

export const getCircularProgressSize = (size: ProgressSize) => {
  switch (size) {
    case 'x-small': {
      return { size: 20, thickness: 3 };
    }
    case 'small': {
      return { size: 28, thickness: 4 };
    }
    case 'medium': {
      return { size: 40, thickness: 5 };
    }
    case 'large': {
      return { size: 48, thickness: 6 };
    }
    default: {
      return { size: 40, thickness: 5 };
    }
  }
};

export const getLinearProgressSize = (size: NonNullable<LinearProgressProps['size']>) => {
  if (typeof size === 'number') {
    return setHeight(size);
  }

  switch (size) {
    case 'x-small': {
      return 'h-4';
    }
    case 'small': {
      return 'h-[0.5rem]';
    }
    case 'medium': {
      return 'h-6';
    }
    case 'large': {
      return 'h-8';
    }
    default: {
      return 'h-6';
    }
  }
};

export const getProgressColorClasses = (color: ProgressColor) => {
  switch (color) {
    case 'inverse': {
      return { progress: 'text-icon-white', track: 'text-bg-primary opacity-[0.2]' };
    }
    case 'success': {
      return { progress: 'text-icon-success', track: 'text-border-medium opacity-[0.55]' };
    }
    default: {
      return { progress: 'text-icon-active', track: 'text-border-medium opacity-[0.55]' };
    }
  }
};
